import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Player from "@/pages/Player";
import TvPlayer from "@/pages/TvPlayer";
import Manage from "@/pages/Manage";
import DownloadPage from "@/pages/Download";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-zinc-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/player" element={<Player />} />
          <Route path="/tv" element={<TvPlayer />} />
          <Route path="/manage" element={<Manage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
